/* Optional photo rotation built on Dawn's gallery. Native media/variant code remains authoritative. */
if (!customElements.get('bc-gallery-player')) {
  customElements.define('bc-gallery-player', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.visible = false;
      this.interacting = false;
      this.paused = false;
      this.interval = Math.max(3000, Number(this.dataset.interval) || 5000);
      this.addEventListener('pointerenter', () => { this.interacting = true; this.schedule(); }, options);
      this.addEventListener('pointerleave', () => { this.interacting = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
      this.addEventListener('pointerdown', () => { this.paused = true; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => this.schedule(), options);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.schedule(); }, { threshold: .4 });
      this.observer.observe(this);
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.motion.matches || this.interacting || this.paused || !this.visible || document.hidden || window.Shopify?.designMode) return;
      this.timer = setTimeout(() => {
        const gallery = this.querySelector('media-gallery');
        if (!gallery || typeof gallery.setActiveMedia !== 'function' || !gallery.dataset.desktopLayout?.includes('thumbnail')) return;
        const slides = [...gallery.querySelectorAll('[id^="GalleryViewer"] [data-media-id]')].filter(slide => slide.querySelector('.product__modal-opener--image') && !slide.classList.contains('product__media-item--variant'));
        // Never interrupt video, 3D media, variant selection or an open zoom dialog.
        if (!slides.some(slide => slide.classList.contains('is-active')) || document.querySelector('product-modal[open]')) return;
        if (slides.length > 1) {
          const active = slides.findIndex(slide => slide.classList.contains('is-active'));
          gallery.setActiveMedia(slides[(active + 1) % slides.length].dataset.mediaId, false);
        }
        this.schedule();
      }, this.interval);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
  });
}
